/** 근무인정 스위치를 직접 편집할 수 있는 외출 구분 코드이다. */
export const ATTEND_GROUP_OUTING = 'G5';

/** 그리드 컬럼의 필드명과 사용자 표시명을 연결한다. */
export const headerNames_HRM2130_R01: Record<string, string> = {
    rowIndex: '',
    attendCd: '근태코드',
    attendNm: '근태명',
    attendGroup: '근태구분',
    useYn: '사용',
    workYn: '근무인정',
    sortSeq: '순서',
    remark: '비고',
};

